import React from "react";
import {
  FishboneAnalysisComponent,
  WhyWhyAnalysisComponent,
} from "../../../../components/RCA";
import type {
  FishboneAnalysis,
  WhyWhyAnalysisEntry,
} from "../../../../components/RCA/types";
import type { GenericRCAFormData } from "./types";

interface RCARootCauseAnalysisSectionProps {
  rcaMethod: GenericRCAFormData["rcaMethod"];
  fishboneAnalysis: FishboneAnalysis;
  whyWhyAnalysis: WhyWhyAnalysisEntry[];
  rootCauseDescription: string;
  onChange: (field: keyof GenericRCAFormData, value: any) => void;
  readOnly: boolean;
}

const RCARootCauseAnalysisSection: React.FC<RCARootCauseAnalysisSectionProps> = ({
  rcaMethod,
  fishboneAnalysis,
  whyWhyAnalysis,
  rootCauseDescription,
  onChange,
  readOnly,
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold mb-4">G. Root Cause Analysis</h3>
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">RCA Method</label>
        <select
          value={rcaMethod}
          onChange={(e) => onChange("rcaMethod", e.target.value as any)}
          className="w-full p-2 border rounded"
          disabled={readOnly}
        >
          <option value="Fishbone">Fishbone Analysis</option>
          <option value="Why-Why">Why-Why Analysis</option>
          <option value="Both">Both</option>
        </select>
      </div>

      {(rcaMethod === "Fishbone" || rcaMethod === "Both") && (
        <FishboneAnalysisComponent
          fishboneAnalysis={fishboneAnalysis}
          rootCauseDescription={rootCauseDescription}
          onChange={(updated) => onChange("fishboneAnalysis", updated)}
          readOnly={readOnly}
        />
      )}

      {(rcaMethod === "Why-Why" || rcaMethod === "Both") && (
        <WhyWhyAnalysisComponent
          whyWhyAnalysis={whyWhyAnalysis}
          onChange={(updated) => onChange("whyWhyAnalysis", updated)}
          readOnly={readOnly}
        />
      )}
    </div>
  );
};

export default RCARootCauseAnalysisSection;
